export default {
  RESTART: 'Začať odznova',
  ATTENTION_CLEAN_DATA: 'Pozor! Všetky údaje budú natrvalo odstránené. Naozaj chcete začať odznova?',
  SELECT_CONTAINER_TYPE: 'Vyberte typ kontajnera',
  SELECT_CONTAINER_DESCRIPTION: 'Pred spustením nároku musíte vybrať základný typ kontajnera. Pozor! Po vytvorení projektu nemôžete zmeniť typ kontajnera!',
  LABEL_CONTINUE: 'Ďalej',
  LABEL_CANCEL: 'Zrušiť',
  LABEL_SEND: 'Odoslať',
  LABEL_SKIP_ALL: 'Preskočiť všetko',
  LABEL_NEXT: 'Ďalej',
  LABEL_VOLUME: 'Objem',
  LABEL_WIDTH: 'Šírka',
  LABEL_HEIGHT: 'Výška',
  LABEL_LENGTH: 'Dĺžka',
  LABEL_EXT_FINISHING: 'Vonkajšia úprava',
  LABEL_INT_FINISHING: 'Interiérová dekorácia',
  LABEL_WALLS: 'Steny',
  LABEL_COATING: 'Náter',
  LABEL_FLOOR: 'Poschodie',
  LABEL_MATERIAL: 'Materiál',
  LABEL_ADDITIONAL: 'Pridať. Prvky',

  LABEL_TYPE: 'Typ',
  LABEL_SIZE: 'Veľkosť',
  LABEL_TOP_AND_BOTTOM: 'Spodná a horná časť',
  LABEL_TOP_PART: 'Vrchná časť',
  LABEL_COLOR: 'Farba',
  LABEL_LOCKS: 'Zámky',
  CLOSER: 'Bližšie',
  LATTICE: 'Mriežka',
  ROLLER_SHUTTERS: 'Rolety',

  COLOR_WHITE: 'Biely',
  LAMINATION: 'Laminovanie',

  COST_POSTFIX: 'EUR',

  FREE: 'Zadarmo',
  FIRST_LOCK: '1. zámok',
  SECOND_LOCK: '2. zámok',
  INSIDE_LOCK: 'Vnútorný zámok',

  REPLACE_LEATHER_WITH_METAL: 'Výmena koženky za kov',

  CARCASS_FORCE: 'Zosilnenie rámu',
  CARCASS_COLOR: 'Farba rámu',
  CARCASS_COLOR_DESCRIPTION: 'Zmena farby drôtového modelu sa vzťahuje na celý projekt.',

  WALLS_MATERIAL_DESCRIPTION: 'Zmena materiálu steny sa aplikuje na celý projekt',
  FLOOR_MATERIAL_DESCRIPTION: 'Zmeny podlahovej krytiny sa aplikujú na celý projekt',

  MOBILE_POPUP_ATTENTION_TITLE: 'Konfigurátor Kontajnery.sk',
  MOBILE_POPUP_ATTENTION_DESCRIPTION: 'Pre pohodlné používanie konfigurátora ho otvorte na stolnom počítači alebo notebooku.',
  MOBILE_POPUP_ATTENTION_LINK_TEXT: 'Prejdite na hlavnú stránku kontajnery.sk',
  PROJECT_SENT: 'Projekt bol úspešne odoslaný',
  PROJECT_SENT_DESCRIPTION: 'Projekt (PDF) a odkaz na jeho úpravu bol odoslaný na Váš e-mail',
  SEND_PROJECT_TO_EMAIL: 'Odoslať projekt na e-mail',
  SEND_PROJECT_TO_EMAIL_DESCRIPTION:'E-mailom dostanete súbor PDF s projektom a odkaz na jeho úpravu. K úprave Projektu sa môžete kedykoľvek vrátiť, stačí kliknúť na odkaz v pošte.',
  WITHOUT_SURCHARGE: 'Bez príplatku',
  SMALL_TOOLTIP_TEXT: 'Použite ľavé tlačidlo myši alebo touchpad na otáčanie budovy a pravé tlačidlo na ťahanie kontajnera',

  BLOCKS_COUNT: 'Počet blokov',
  BLOCKS_COUNT_2: 'Bloky',
  BLOCKS_STAGES: 'Podlahy',
  BLOCKS_SQUARE: 'Námestie',

  SQUARE_POSTFIX: "m²",

  TOOLTIP_1_TITLE: 'Pridávanie kontajnerov',
  TOOLTIP_1_TEXT: 'Kliknutím na plusy pridáte nové kontajnery',
  TOOLTIP_2_TITLE: 'Pridávanie objektov',
  TOOLTIP_2_TEXT: 'Presuňte potrebné priečky, okná, dvere a ďalšie objekty priamo do diagramu.',
  TOOLTIP_3_TITLE: 'Zrušiť akciu',
  TOOLTIP_3_TEXT: 'Predchádzajúce akcie môžete kedykoľvek vrátiť späť.',
  TOOLTIP_4_TITLE: 'Podlahy',
  TOOLTIP_4_TEXT: 'Prepínajte medzi poschodiami, pridávajte alebo kopírujte poschodia.',
  TOOLTIP_5_TITLE: 'Uloženie aplikácie',
  TOOLTIP_5_TEXT: 'Stiahnite si PDF s projektom alebo pošlite projekt na Váš e-mail spolu s odkazom na ďalšie úpravy.',
  TOOLTIP_6_TITLE: 'Snímky obrazovky',
  TOOLTIP_6_TEXT: 'Urobte snímku obrazovky výsledného projektu.',
  TOOLTIP_7_TITLE: 'Začať odznova',
  TOOLTIP_7_TEXT: 'Kedykoľvek môžete začať nový projekt.',
  TOOLTIP_8_TITLE: 'Modulový stavebný detail',
  TOOLTIP_8_TEXT: 'Skontrolujte zloženie modulárnej budovy podľa sekcií a spravujte detaily. V časti „Pridať. prvky“ môžete zanechať špeciálne pokyny pre našich manažérov.',
  TOOLTIP_9_TITLE: 'Režim zobrazenia dokončenej budovy',
  TOOLTIP_9_TEXT: 'Pozrite sa, ako bude Vaša kontajnerová zostava vyzerať v 3D.',
  TOOLTIP_10_TITLE: 'Odhlásiť sa',
  TOOLTIP_10_TEXT: 'Pokračujte k pokladni. Potom môžete zadať dodaciu adresu a podmienky inštalácie.',
  TOOLTIP_11_TITLE: 'Tipy',
  TOOLTIP_11_TEXT: 'Použite rady kedykoľvek.',
  TOOLTIP_12_TITLE: 'Režim úprav',
  TOOLTIP_12_TEXT: 'Ak chcete projekt upraviť, prepnite do 2D režimu.',
  TOOLTIP_13_TITLE: 'Dokončovanie',
  TOOLTIP_13_TEXT: 'Zmeňte farby rámu a vonkajších stien kontajnera.',
  TOOLTIP_14_TITLE: 'Priehľadné steny',
  TOOLTIP_14_TEXT: 'Zapnite tento režim, aby ste videli cez steny.',
  TOOLTIP_15_TITLE: 'Snímky obrazovky',
  TOOLTIP_15_TEXT: 'Vždy si môžete urobiť niekoľko snímok obrazovky svojej kontajnerovej zostavy.',
  TOOLTIP_16_TITLE: 'Tipy',
  TOOLTIP_16_TEXT: 'Použite rady kedykoľvek.',

  EQ_ITEM_CARCASS: 'Rám',
  EQ_ITEM_EXT_FINISHING: 'Vonkajšie dokončovacie',
  EQ_ITEM_ROOF: 'Strecha',
  EQ_ITEM_WINDOWS: 'Okno',
  EQ_ITEM_DOORS: 'Dvere',
  EQ_ITEM_INT_FINISHING: 'Dokončovanie interiéru',
  EQ_ITEM_FLOOR: 'Poschodie',
  EQ_ITEM_PLUMBING: 'Inštalatérstvo / Sanita',
  EQ_ITEM_WARMING: 'Zatepľovanie',
  EQ_ITEM_WATERPROOF: 'Vodeodolný',
  EQ_ITEM_ELECTRIC: 'Elektrikár',
  EQ_ITEM_ADDITIONAL: 'Pridať prvky',
  EQ_ITEM_MOUNTING: 'Montáž',

  CONTAINER_TYPE_STANDARD: 'Štandardné',
  CONTAINER_TYPE_IMPROVED: 'Vylepšené',

  SANDWICH_PANEL_WALLS: 'Sendvičové panelové steny',
  WOODEN_WALLS: 'Steny s dreveným obkladom',

  MATERIALS_TAB_CARCASS: 'Rám',
  MATERIALS_TAB_EXT: 'Vonku',
  MATERIALS_TAB_ROOF: 'Strecha',

  ADDITIONAL_HEATER: 'Ohrievač',
  ADDITIONAL_HOOD: 'Ventilácia',
  ADDITIONAL_HAND_DRYER: 'Sušič rúk',

  HEATING_BATTERY_INFO: 'Vykurovacie batérie vyberte iba vtedy, ak sa na miesto dodáva teplá voda',
  MIXER_INCLUDED: 'Vrátane batérií',

  WOODEN_WINDOW: 'Drevené okno',
  WOODEN_WINDOWS: 'Drevené okná',
  PLASTIC_WINDOW: 'Plastové okno',
  PLASTIC_WINDOWS: 'PLASTOVÉ',

  WINDOW: 'Okno',
  DOOR: 'Dvere',
  HOOD: 'Ventilácia',
  CONTAINER: 'Kontajner',
  SINK: 'Drez',
  BOILER: 'Bojler',
  TOILET: 'Toaleta / WC',
  SHOWER: 'Sprcha',
  HAND_DRYER: 'Sušič rúk',
  HEATER: 'Ohrievač',
  LADDER: 'Rebrík',
  BATTERY: 'Batéria',
  PARTITION: 'Priečka',

  CONSTRUCTIONS: 'Konštrukcie',
  WINDOWS: 'Okna',
  DOORS: 'Dvere',
  PLUMBING: 'Inštalatérstvo / Sanita',
  SECOND_FLOOR: 'Druhé poschodie',
  FINISHING: 'Dokončovanie',

  COST: 'Cena',

  TIME_FOR_PRODUCT: 'Čas výroby',
  LABEL_ORDER: 'Objednať',

  STAGE: 'Poschodie',
  EDIT_MODE_DESCRIPTION: 'Prepnite do 2D režimu pre jednoduchú úpravu projektu. V 3D režime je celý projekt jasne viditeľný.',
  ADDITIONAL_COMMENTS: 'Tu môžete zanechať ďalšie želania a komentáre.',

  LABEL_SAVE: 'Uložiť',

  ORG_NAME: 'Názov spoločnosti',
  ORG_TIN: 'IČO',
  ORG_PERSON: 'Kontaktná osoba',
  PHONE: 'Telefón',
  EMAIL: 'E-mail',
  DELIVERY: 'Dodanie',
  DELIVERY_DATE: 'Dátum dodania',
  DELIVERY_COST: 'Náklady za dopravu:',
  DELIVERY_ADDRESSES: 'Adresa dodania',
  CRANE_UNLOADING: 'Vykládka pomocou žeriavu kupujúceho',
  MOUNTING: 'Montáž (spájanie)',

  ERROR_FIELD_REQUIRED: 'Pole musí byť vyplnené',

  PROJECT_NAME: 'Projekt "Štandard"',

  WOODEN_PROJECT: 'Kontajnery s drevodekórom',
  SANDWICH_PROJECT: 'Sandvičové kontajnery',
  PRODUCTION_TIME: 'Čas výroby na mieru',
  PRODUCTION_DAYS: '14 - 21 dní',

  DRAW_UP_PROJECT: 'Dizajn',
  ORDER_COMPLETE: 'Konfigurácia dokončená',
  ORDER_COMPLETE_DESCRIPTION: 'Konfigurácia č. {pid} bola úspešne dokončená. Náš obchodný manažér Vás bude čoskoro kontaktovať, aby potvrdil objednávku. Kópia projektu bola odoslaná na Váš e-mail.',
  DOWNLOAD_ORDER_PDF: 'Stiahnuť konfiguráciu v PDF',

  ENTER_ADDRESS: 'Zadajte adresu a stlačte "Enter"',
  FIND: 'Nájsť',
  LOCATION_TIP: '*Pre presnejšiu definíciu je možné presunúť značku na mape',
  LABEL_APPLY: 'Použiť',

  SEND_ON_EMAIL: 'Odoslať na mail',

  HELP: 'Pomoc',

  TRANSPARENT_WALLS: 'Priehľadné steny',
  HIDE_ROOF: 'Neukazujte strechu',
  IMMERCYB: 'BAUGRUP',

  DOWNLOAD_SCREENSHOT: 'Stiahnite si snímku obrazovky',
  SCREENSHOT_TIP: 'Môžete zmeniť pomer strán a veľkosť snímky obrazovky. Obrázok sa uloží vo formáte JPEG.',

  DOWNLOAD: 'Stiahnuť',

  FIRST_STEPS_TITLE: 'Pred spustením...',

  BACK: 'Späť',

  CHECKOUT_PROCESS: 'Odhlásiť sa',
  CHECKOUT_STEP: 'Krok {step} z 2',

  SCHEDULE: 'Po-Pia 7:00-16:00 hod.',

  ORDER: 'Objednávka',

  CORNER_POSTS: 'Rohové stĺpiky',
  CARCASS_CHANNEL: 'Kanál',
  CRATE: 'Steny',
  COAT_TYPE: 'Typ strechy',
  METAL_TRUSSES: 'kovové väzníky',
  WALL_METALL: 'kovové. plech 0,45 mm',
  CONTAINERS_DIFFERENT_COLOR: 'iná farba pre <br/>jednotlivé kontajnery',
  CONTAINERS_DIFFERENT_COATING: 'Iný kryt pre jednotlivé kontajnery',
  CONTAINERS_DIFFERENT_MATERIAL: 'Rôzny materiál pre<br/>jednotlivé kontajnery',
  ROOM_PARTITION_TYPE: 'Typ vnútorných priečok',
  FLOOR_SUB: 'Spodná časť',
  TILED_INSULATION: 'Izolácia podlahy',
  PART_OF_PRICE: 'zahrnutá v cene',
  ADDITIONAL_LAGS: 'Ďalšie oneskorenia',
  METAL_LAGS: 'Metal zaostáva',
  CLEAN_FLOOR: 'Hotová podlaha',
  COMMON_FLOOR: 'Hlavné poschodie',
  FLOOR_ADDITIONAL_LAYER: 'Extra vrstva',
  NO_ELEMENTS: 'Neboli pridané žiadne položky',
  STANDART: 'Štandardné',
  WARMING_TYPE: 'Typ izolácie',
  WARMING_WIDTH: 'Hrúbka izolácie',
  GYDRO_INSIDE_B: 'Hydroprof interný, B',
  GYDRO_INSIDE_A: 'Hydroprof interný, A',
  GYDRO_EXT_A: 'Hydroprof externý, A',
  GYDRO_EXT_A: 'Hydroprof externý, B',
  SOCKETS: 'ZÁSUVKY',
  FOR_ONE_ITEM: 'pre 1 položku',
  LIGHTING: 'OSVETLENIE',
  ADDITIONAL_COMMENT_TEXT: 'Pridajte ďalšie pokyny',
  CLIENT: 'Zákazník',
  PREPEARED_FLOOR: 'Návrh podlahy',
  ADDITIONAL_FLOOR: 'Dodatočné dno',
  FLOOR_ADITIONAL_METAL_LAGS: 'Počet dodatočných kovových oneskorení',
  PVC_FILM_40: 'PVC fólia 40 mikrónov',
  BLOCK_CONTAINER: 'Blokový kontajner',

  DOORS_EXT: 'Vonkajšie dvere',
  DOORS_INT: 'Interiérové dvere',
  DOORS_OTHER: 'Zmiešaný',

  INPUT_RAL: 'Zadajte číslo RAL',

  TOOLTIP_3D: 'Použite ľavé tlačidlo myši alebo touchpad na otáčanie budovy a pravé tlačidlo na ťahanie budovy',
  TOOLTIP_2D: 'Kliknutím na kontajner zmeníte jeho dĺžku. Kým je zvýraznený červenou farbou, potiahnite ho za roh, aby ste roztiahli alebo skrátili dĺžku kontajnera'
}
